import Backbone from 'backbone';
import _ from 'underscore';

var dispatcher = _.extend({}, Backbone.Events);
dispatcher.on('all', function (action, payload) {
  console.log('Action Dispatched: ', action, payload);
});

export default dispatcher;
